// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__yLS7-","requiredAsterisk":"Info_requiredAsterisk__3tTu-"};